import { useMediaQuery } from '@patrianna/shared-hooks'
import type { ActiveRoom } from '@patrianna/shared-patrianna-types/store/BingoModule'
import type { GameProductShort } from '@patrianna/shared-patrianna-types/store/GameModule'
import cx from 'classnames'

import { PARLAY_ROOM_CODES_GC, PARLAY_ROOM_CODES_SC } from 'config/parlay-rooms-codes'
import GameRowHeader from 'src/components/GameRowHeader'
import HorizontalScroll from 'src/containers/HorizontalScroll'
import slotsClasses from 'src/pageContainers/Home/components/SlotsRow/styles.module.scss'
import { useAppSelector } from 'src/store/hooks'
import { getActiveCurrencyIdSelector } from 'store/modules/currencies/selectors'
import { INTERNAL_GAME_NAVIGATION, setDataToSessionStorage } from 'utils/sessionStorage'

import BingoTile from '../BingoTile'

import classes from './styles.module.scss'

// import { filterAndSortBingoProducts } from './utils'

type Props = {
  rooms: ActiveRoom[]
  bingoProducts: GameProductShort[]
  title: string
  url?: string
  lines?: number
  count?: number
  iconImg?: string
  // bingoDisabled props is used for temporarily disable bingo games
  bingoDisabled?: boolean
  layout?: string
}

export default function BingoRooms({
  rooms,
  bingoProducts,
  title,
  iconImg,
  lines,
  bingoDisabled = false,
  layout,
}: Props) {
  const isMobile = useMediaQuery('xs')
  const activeCurrency = useAppSelector(getActiveCurrencyIdSelector)
  const parlayRoomCodes = activeCurrency === 'SC' ? PARLAY_ROOM_CODES_SC : PARLAY_ROOM_CODES_GC
  const filteredRooms =
    rooms
      ?.filter((room) => room?.code && parlayRoomCodes.includes(room.code as string))
      .sort((a, b) => {
        return parlayRoomCodes.indexOf(a.code as string) - parlayRoomCodes.indexOf(b.code as string)
      }) ?? []
  // const activeCurrencyRoomMode = activeCurrency === 'SC' ? 'sweepstake' : 'gold'
  // TODO: uncomment and user after backend update categories response
  // const sortedBingoRooms = filterAndSortBingoProducts(bingoProducts, rooms, activeCurrencyRoomMode)

  // Construct the URL based on the active currency
  const bingoUrl = activeCurrency === 'SC' ? '/bingo/sweepstake/play' : '/bingo/play'

  if (bingoDisabled) {
    return (
      <>
        <GameRowHeader title={title} iconImg={iconImg} url={bingoUrl} />
        <div
          className={classes.bingoPlaceholder}
          style={{
            backgroundImage: `url('${process.env.IMG_ORIGIN}/empty-bingo-banner/${isMobile ? 'emptyBingoBannerMobile' : 'emptyBingoBannerDesktop'}.png')`,
          }}
        />
      </>
    )
  }

  return filteredRooms.length > 0 ? (
    <>
      <GameRowHeader
        title={title}
        iconImg={iconImg}
        url={`${bingoUrl}?refererPath=showAll`}
        onClick={() => {
          setDataToSessionStorage(INTERNAL_GAME_NAVIGATION, 'true')
        }}
      />

      <HorizontalScroll
        data-test={`${title}-games-row`}
        classNameContainer={cx(slotsClasses.root, classes.bingoRoomsContainerRoot, classes.bingoRoomsContainerRoot3D)}
        styleContainer={{
          gridTemplateRows: `repeat(${lines}, auto)`,
        }}
      >
        {filteredRooms.map((el, index) => (
          <BingoTile
            with3DImage
            room={el as unknown as GameProductShort}
            key={el.code || el.title}
            gameIndex={index + 1}
            layout={layout}
          />
        ))}
      </HorizontalScroll>
    </>
  ) : null
}
